var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g, _path20, _g2, _path21, _g3, _path22, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneticAncestry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 160,
    viewBox: "0 0 137 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5084 158.919L60.0856 158.518C53.7432 152.597 50.3384 143.937 51.6959 135.367C55.2788 112.549 82.6731 114.308 82.0945 97.3228C81.6494 84.5228 66.0941 82.3857 57.5041 73.793L57.0145 73.2365C49.0032 64.7329 49.426 52.8456 58.016 44.7203L74.9956 29.7388C82.3393 23.6616 85.9667 15.2692 84.8985 6.81008L84.1641 1",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7965 158.919L76.2193 158.518C82.5616 152.597 85.9664 143.937 84.609 135.367C81.0261 112.549 53.6317 114.308 54.2103 97.3228C54.6554 84.5228 70.2108 82.3857 78.8007 73.793L79.2903 73.2365C87.3017 64.7329 86.8788 52.8456 78.2889 44.7203L61.3093 29.7388C53.9656 23.6616 50.3382 15.2692 51.4064 6.81008L52.1407 1",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8789 5.40723H80.447",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3105 26.0879H74.016",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8789 12.7764H80.447",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5244 19.5215H79.7796",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3105 46.9688H74.016",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8789 62.2842H80.447",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5244 55.0273H79.7796",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3955 69.6973H76.9315",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3105 91.4014H74.016",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58.082 97.9238H78.2439",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3076 104.491H76.0188",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3096 124.793H75.0179",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8789 140.954H80.447",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8789 132.873H80.447",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9697 148.122H79.3347",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M61.71 155.312H74.5949",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2323_21497",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 19,
    width: 52,
    height: 112
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6954 19.1426H0V130.825H51.6954V19.1426Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2323_21497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.0385 26.667C42.9495 26.3108 42.8605 25.9546 42.7047 25.643L40.3903 20.2559C40.3903 20.2559 37.5196 23.3501 37.0523 23.8844C34.9827 26.244 34.8491 28.4256 35.361 30.0952C35.8506 31.7425 37.1413 32.6552 38.5878 32.7665",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6994 27.5578C38.3879 27.8917 38.4769 28.3147 38.5436 28.5596C38.5659 28.6486 38.6104 28.7154 38.6772 28.7599C38.9219 28.4037 39.2113 28.0698 39.6118 27.7804C39.6563 27.7582 39.6786 27.7359 39.7231 27.7137L39.3003 26.7119C39.3225 26.7119 38.7662 27.4688 38.6994 27.5578Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0429 27.3126C44.9302 26.8673 43.9288 26.667 43.0386 26.667C43.2834 27.7578 43.2167 28.9821 42.8384 30.0061C42.9274 30.0061 43.0164 30.0284 43.1276 30.0729C43.2167 30.1174 44.1291 30.3846 44.1291 30.3846L43.2389 31.1859C43.0164 31.4086 42.46 31.4308 42.2152 31.2527C42.2152 31.2527 42.2152 31.2305 42.193 31.2305C42.015 31.4531 41.8369 31.6534 41.6144 31.8315C40.6797 32.5661 39.5893 32.8555 38.5879 32.7665C38.9217 33.323 39.4113 33.835 40.0344 34.2357C41.7257 35.3265 44.6409 34.7477 46.2432 33.234L50.5604 29.2715C50.5827 29.2715 46.7105 27.5797 46.0429 27.3126Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6992 28.7591C38.8995 28.9595 39.2333 29.004 39.5226 28.8037C39.7674 28.6256 39.9454 28.0913 39.7896 27.8242L39.7451 27.7129C39.7006 27.7352 39.6784 27.7574 39.6339 27.7797C39.2333 28.0468 38.944 28.403 38.6992 28.7591Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2148 31.2525C42.4596 31.4306 43.016 31.4083 43.2385 31.1857L44.1287 30.3843C44.1287 30.3843 43.2163 30.1172 43.1272 30.0726C43.0382 30.0281 42.9492 30.0059 42.838 30.0059C42.6822 30.4511 42.4819 30.874 42.2148 31.2525ZM42.2148 31.2525C42.2148 31.2302 42.2148 31.2302 42.2148 31.2525Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3959 44.0752C44.3959 44.0752 41.0134 46.6129 40.457 47.0582C38.0091 49.0171 37.4973 51.1319 37.6975 52.8682C38.0314 55.7622 40.9688 57.031 43.5503 55.6731C45.3528 54.7382 46.2652 51.911 45.7089 49.774L44.3959 44.0752Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1926 50.2412C42.1926 50.2412 41.525 50.909 41.436 50.9758C41.0577 51.243 41.08 51.6882 41.1245 51.933C41.1912 52.356 41.6363 52.5341 42.0146 52.3337C42.2817 52.2002 42.5487 51.7104 42.4597 51.3988L42.1926 50.2412Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6801 28.8711C25.6801 28.8711 24.5674 32.9448 24.3894 33.6349C23.6328 36.6847 24.5452 38.6659 25.7469 39.9347C27.772 42.0273 30.8875 41.2481 32.0892 38.5768C32.9348 36.7292 31.9334 33.9466 30.1976 32.5887L25.6801 28.8711Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7055 35.1045C27.7055 35.1045 27.572 36.0395 27.5497 36.1508C27.4162 36.596 27.7055 36.9299 27.8836 37.108C28.1729 37.3974 28.6402 37.2861 28.8405 36.8854C28.974 36.6182 28.885 36.0617 28.6402 35.8836L27.7055 35.1045Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2638 38.4434C14.2638 38.4434 14.2193 42.6729 14.2416 43.3853C14.3083 46.5241 15.6881 48.2159 17.1791 49.1063C19.6715 50.5978 22.4755 49.0395 22.9651 46.1679C23.2989 44.1644 21.6298 41.7157 19.6047 40.8698L14.2638 38.4434Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8018 43.9414C17.8018 43.9414 17.913 44.8764 17.913 44.9877C17.913 45.4551 18.2691 45.7 18.4694 45.8113C18.8254 46.0117 19.2483 45.7668 19.3373 45.3438C19.404 45.0544 19.1592 44.5424 18.8699 44.4311L17.8018 43.9414Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8291 53.2465C4.8291 53.2465 7.27702 56.6747 7.72209 57.2535C9.63591 59.769 11.7278 60.3032 13.4636 60.1474C16.3565 59.8803 17.714 56.9863 16.401 54.3596C15.5109 52.5342 12.7069 51.5547 10.5483 52.0444L4.8291 53.2465Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9492 55.606C10.9492 55.606 11.5946 56.2961 11.6613 56.3852C11.9284 56.7636 12.3512 56.7636 12.596 56.7191C13.0188 56.6746 13.1968 56.2293 13.0188 55.8286C12.8853 55.5615 12.418 55.2721 12.1064 55.3612L10.9492 55.606Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1123 66.0685C1.1123 66.0685 5.2515 65.2671 5.96362 65.1336C9.05689 64.6216 10.9707 65.6678 12.1279 66.9812C14.064 69.1628 13.0403 72.1903 10.3031 73.2143C8.41153 73.9266 5.69658 72.7023 4.47262 70.8769L1.1123 66.0685Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16504 68.5394C7.16504 68.5394 8.09969 68.4726 8.21096 68.4726C8.65604 68.3836 8.96759 68.673 9.12337 68.8733C9.39041 69.185 9.23464 69.6525 8.83407 69.8083C8.56702 69.9196 8.01068 69.786 7.8549 69.5189L7.16504 68.5394Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1123 80.9385C1.1123 80.9385 4.82868 78.9573 5.47404 78.6234C8.27801 77.221 10.4144 77.6662 11.9054 78.5789C14.3978 80.0926 14.3088 83.2982 11.9944 85.079C10.3921 86.3034 7.43237 85.9472 5.74108 84.567L1.1123 80.9385Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.63281 81.5173C7.63281 81.5173 8.52296 81.1834 8.61198 81.1389C9.01255 80.9163 9.39086 81.1166 9.61339 81.2502C9.96945 81.4728 9.9472 81.9625 9.61339 82.2297C9.39086 82.43 8.83452 82.4523 8.58972 82.2519L7.63281 81.5173Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8232 111.637C16.8232 111.637 15.9998 107.496 15.8663 106.784C15.3322 103.69 16.3781 101.775 17.6688 100.595C19.8497 98.6586 22.8762 99.6603 23.8999 102.398C24.612 104.291 23.4103 107.006 21.5855 108.253L16.8232 111.637Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2716 105.582C19.2716 105.582 19.2048 104.647 19.1826 104.536C19.0936 104.09 19.3829 103.779 19.5832 103.623C19.8947 103.356 20.362 103.512 20.5178 103.912C20.6291 104.18 20.4956 104.736 20.2285 104.892L19.2716 105.582Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8721 64.7549C19.8721 64.7549 20.0278 68.9845 20.0724 69.6968C20.2726 72.8356 21.7191 74.4606 23.2546 75.2843C25.8138 76.6644 28.551 74.9949 28.9071 72.101C29.1519 70.0975 27.3716 67.7156 25.302 66.9587L19.8721 64.7549Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6777 70.0977C23.6777 70.0977 23.8335 71.0326 23.8335 71.1439C23.8558 71.6114 24.2118 71.834 24.4344 71.9453C24.8127 72.1457 25.2132 71.8785 25.28 71.4556C25.3245 71.1662 25.0797 70.6542 24.7682 70.5651L23.6777 70.0977Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.38184 96.0321C3.38184 96.0321 7.32075 97.5458 7.98836 97.7907C10.9481 98.8369 13.0177 98.1468 14.3752 97.0561C16.6451 95.2307 16.1777 92.0696 13.6631 90.6004C11.905 89.5764 9.03429 90.2888 7.52103 91.8915L3.38184 96.0321Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.76855 94.6293C9.76855 94.6293 10.681 94.8519 10.7922 94.8964C11.215 95.0745 11.5711 94.8296 11.7714 94.6515C12.0829 94.3844 12.0162 93.9169 11.6379 93.6721C11.3931 93.5162 10.8367 93.5385 10.6142 93.7833L9.76855 94.6293Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9519 117.692C28.9519 117.692 31.9784 114.754 32.4902 114.242C34.6934 111.993 34.9159 109.834 34.5153 108.12C33.8255 105.293 30.7544 104.38 28.3733 106.05C26.7043 107.207 26.1479 110.123 26.949 112.171L28.9519 117.692Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3764 111.303C30.3764 111.303 30.955 110.569 31.044 110.48C31.3779 110.168 31.3111 109.745 31.2443 109.5C31.1331 109.099 30.6657 108.966 30.3097 109.211C30.0649 109.367 29.8646 109.901 29.9759 110.19L30.3764 111.303Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6094 129.69C38.6094 129.69 42.6373 128.399 43.3049 128.177C46.2647 127.13 47.4441 125.305 47.8224 123.591C48.4678 120.742 46.1089 118.582 43.2159 119.005C41.2131 119.317 39.4105 121.677 39.2325 123.858L38.6094 129.69Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7266 124.593C42.7266 124.593 43.5722 124.192 43.6835 124.148C44.1285 124.014 44.2398 123.591 44.3066 123.346C44.3956 122.946 44.0395 122.612 43.5945 122.656C43.3052 122.701 42.8823 123.057 42.8601 123.391L42.7266 124.593Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0041 95.2303L42.1486 76.3308C41.0359 73.704 39.6562 71.1885 38.0539 68.8066L35.1164 64.4435C33.0245 61.3492 31.8673 57.6984 31.8228 53.9586L31.7783 50.4414C31.7338 47.3471 32.4459 44.2751 33.8257 41.5148L37.6533 33.9238",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5635 49.7734C25.6582 56.051 33.1132 60.6145 33.1132 60.6145",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5361 58.3662L20.2066 59.1899C29.3751 62.0393 38.0541 68.8066 38.0541 68.8066",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5723 75.707L27.7058 75.9742C28.7072 77.9999 30.1982 79.7363 32.0675 80.9829L36.7631 84.1439C37.6087 84.7227 38.4098 85.3237 39.1887 85.9916L50.004 95.2298",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5023 56.5186C40.5023 56.5186 38.3882 64.7551 41.5259 74.9283",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1338 92.7147L19.6499 89.4646C21.2076 88.0177 23.0102 86.8824 24.9908 86.081L26.2815 85.569C28.5736 84.6563 31.0661 84.2778 33.5362 84.4559L37.3639 84.5227",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7959 72.0342L14.3537 73.7483C16.0004 75.5737 17.892 77.1542 19.9616 78.4898L20.5402 78.8683C23.0771 80.4933 25.8366 81.6954 28.7296 82.4745L37.3418 84.5671",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0869 82.2744C14.0869 82.2744 24.7242 82.7196 28.2403 83.1203C30.2654 83.3429 36.2516 84.456 36.2516 84.456",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6318 100.284L27.817 95.2749C30.1759 92.9821 33.4027 91.8245 36.674 92.0694L47.8453 92.9153",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9102 104.513L31.1549 101.218C31.2662 99.7043 32.0451 97.7008 33.1133 96.5877C33.1133 96.5877 36.5181 93.0037 38.788 92.2246",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7314 41.6709L29.776 41.8935C30.1543 43.6076 30.8219 44.8765 31.801 46.3234",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2323_21497",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 84,
    y: 19,
    width: 53,
    height: 112
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M136.415 19.1426H84.7197V130.825H136.415V19.1426Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2323_21497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.3535 26.667C93.4425 26.3108 93.5315 25.9546 93.6873 25.643L96.0017 20.2559C96.0017 20.2559 98.8724 23.3501 99.3398 23.8844C101.409 26.244 101.543 28.4256 101.031 30.0952C100.541 31.7425 99.2508 32.6552 97.8043 32.7665",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6936 27.5578C98.0051 27.8917 97.9161 28.3147 97.8494 28.5596C97.8271 28.6486 97.7826 28.7154 97.7159 28.7599C97.4711 28.4037 97.1818 28.0698 96.7812 27.7804C96.7367 27.7582 96.7144 27.7359 96.6699 27.7137L97.0927 26.7119C97.0705 26.7119 97.6268 27.4688 97.6936 27.5578Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3495 27.3126C91.4622 26.8673 92.4636 26.667 93.3538 26.667C93.109 27.7578 93.1758 28.9821 93.5541 30.0061C93.4651 30.0061 93.3761 30.0284 93.2648 30.0729C93.1758 30.1174 92.2634 30.3846 92.2634 30.3846L93.1535 31.1859C93.376 31.4086 93.9324 31.4308 94.1772 31.2527C94.1772 31.2527 94.1772 31.2305 94.1994 31.2305C94.3775 31.4531 94.5555 31.6534 94.778 31.8315C95.7127 32.5661 96.8031 32.8555 97.8045 32.7665C97.4707 33.323 96.9812 33.835 96.3581 34.2357C94.6668 35.3265 91.7515 34.7477 90.1493 33.234L85.832 29.2715C85.832 29.2715 89.6819 27.5797 90.3495 27.3126Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7153 28.7591C97.5151 28.9595 97.1812 29.004 96.8919 28.8037C96.6472 28.6256 96.4691 28.0913 96.6249 27.8242L96.6694 27.7129C96.7139 27.7352 96.7362 27.7574 96.7807 27.7797C97.159 28.0468 97.4705 28.403 97.7153 28.7591Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1775 31.2525C93.9327 31.4306 93.3764 31.4083 93.1538 31.1857L92.2637 30.3843C92.2637 30.3843 93.1761 30.1172 93.2651 30.0726C93.3541 30.0281 93.4431 30.0059 93.5544 30.0059C93.7102 30.4511 93.9327 30.874 94.1775 31.2525ZM94.1775 31.2525C94.1997 31.2302 94.1997 31.2302 94.1775 31.2525Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0182 44.0752C92.0182 44.0752 95.4007 46.6129 95.9571 47.0582C98.405 49.0171 98.9168 51.1319 98.7165 52.8682C98.3827 55.7622 95.4452 57.031 92.8638 55.6731C91.0613 54.7382 90.1488 51.911 90.7052 49.774L92.0182 44.0752Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1986 50.2412C94.1986 50.2412 94.8662 50.909 94.9552 50.9758C95.3335 51.243 95.3113 51.6882 95.2668 51.933C95.2 52.356 94.7549 52.5341 94.3766 52.3337C94.1096 52.2002 93.8425 51.7104 93.9315 51.3988L94.1986 50.2412Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.711 28.8711C110.711 28.8711 111.824 32.9448 112.002 33.6349C112.759 36.6847 111.846 38.6659 110.645 39.9347C108.62 42.0273 105.504 41.2481 104.302 38.5768C103.457 36.7292 104.458 33.9466 106.194 32.5887L110.711 28.8711Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.686 35.1045C108.686 35.1045 108.82 36.0395 108.842 36.1508C108.976 36.596 108.686 36.9299 108.508 37.108C108.219 37.3974 107.752 37.2861 107.551 36.8854C107.418 36.6182 107.507 36.0617 107.752 35.8836L108.686 35.1045Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.128 38.4434C122.128 38.4434 122.172 42.6729 122.15 43.3853C122.083 46.5241 120.703 48.2159 119.212 49.1063C116.72 50.5978 113.916 49.0395 113.427 46.1679C113.093 44.1644 114.762 41.7157 116.787 40.8698L122.128 38.4434Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.59 43.9414C118.59 43.9414 118.478 44.8764 118.478 44.9877C118.478 45.4551 118.122 45.7 117.922 45.8113C117.566 46.0117 117.143 45.7668 117.054 45.3438C116.987 45.0544 117.232 44.5424 117.521 44.4311L118.59 43.9414Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.564 53.2465C131.564 53.2465 129.116 56.6747 128.671 57.2535C126.757 59.769 124.665 60.3032 122.929 60.1474C120.036 59.8803 118.679 56.9863 119.992 54.3596C120.882 52.5342 123.686 51.5547 125.844 52.0444L131.564 53.2465Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.466 55.606C125.466 55.606 124.821 56.2961 124.754 56.3852C124.487 56.7636 124.064 56.7413 123.797 56.7191C123.374 56.6746 123.196 56.2293 123.374 55.8286C123.508 55.5615 123.975 55.2721 124.287 55.3612L125.466 55.606Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.28 66.0685C135.28 66.0685 131.141 65.2671 130.429 65.1336C127.335 64.6216 125.422 65.6678 124.264 66.9812C122.328 69.1628 123.352 72.1903 126.089 73.2143C127.981 73.9266 130.696 72.7023 131.92 70.8769L135.28 66.0685Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.227 68.5394C129.227 68.5394 128.292 68.4726 128.181 68.4726C127.736 68.3836 127.424 68.673 127.268 68.8733C127.001 69.185 127.157 69.6525 127.558 69.8083C127.825 69.9196 128.381 69.786 128.537 69.5189L129.227 68.5394Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.302 80.9385C135.302 80.9385 131.586 78.9573 130.941 78.6234C128.137 77.221 126 77.6662 124.509 78.5789C122.017 80.0926 122.106 83.2982 124.42 85.079C126.022 86.3034 128.982 85.9472 130.673 84.567L135.302 80.9385Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.782 81.5173C128.782 81.5173 127.892 81.1834 127.803 81.1389C127.403 80.9163 127.024 81.1166 126.802 81.2502C126.446 81.4728 126.468 81.9625 126.802 82.2297C127.024 82.43 127.581 82.4523 127.825 82.2519L128.782 81.5173Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.569 111.637C119.569 111.637 120.392 107.496 120.526 106.784C121.06 103.69 120.014 101.775 118.723 100.595C116.542 98.6586 113.516 99.6603 112.492 102.398C111.78 104.291 112.982 107.006 114.807 108.253L119.569 111.637Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.121 105.582C117.121 105.582 117.187 104.647 117.21 104.536C117.299 104.09 117.009 103.779 116.809 103.623C116.497 103.356 116.03 103.512 115.874 103.912C115.763 104.18 115.897 104.736 116.164 104.892L117.121 105.582Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.52 64.7549C116.52 64.7549 116.364 68.9845 116.319 69.6968C116.119 72.8356 114.672 74.4606 113.137 75.2843C110.578 76.6644 107.841 74.9949 107.485 72.101C107.24 70.0975 109.02 67.7156 111.09 66.9587L116.52 64.7549Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.736 70.0977C112.736 70.0977 112.581 71.0326 112.581 71.1439C112.558 71.6114 112.202 71.834 111.98 71.9453C111.601 72.1457 111.201 71.8785 111.134 71.4556C111.09 71.1662 111.334 70.6542 111.646 70.5651L112.736 70.0977Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.01 96.0321C133.01 96.0321 129.071 97.5458 128.404 97.7907C125.444 98.8369 123.374 98.1468 122.017 97.0561C119.747 95.2307 120.214 92.0696 122.729 90.6004C124.487 89.5764 127.358 90.2888 128.871 91.8915L133.01 96.0321Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.623 94.6293C126.623 94.6293 125.711 94.8519 125.599 94.8964C125.177 95.0745 124.82 94.8296 124.62 94.6515C124.309 94.3844 124.375 93.9169 124.754 93.6721C124.999 93.5162 125.555 93.5385 125.777 93.7833L126.623 94.6293Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.441 117.692C107.441 117.692 104.414 114.754 103.902 114.242C101.699 111.993 101.477 109.834 101.877 108.12C102.567 105.293 105.638 104.38 108.019 106.05C109.688 107.207 110.245 110.123 109.444 112.171L107.441 117.692Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.016 111.303C106.016 111.303 105.438 110.569 105.349 110.48C105.015 110.168 105.081 109.745 105.148 109.5C105.26 109.099 105.727 108.966 106.083 109.211C106.328 109.367 106.528 109.901 106.417 110.19L106.016 111.303Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7822 129.69C97.7822 129.69 93.7543 128.399 93.0867 128.177C90.1269 127.13 88.9475 125.305 88.5692 123.591C87.9238 120.742 90.2827 118.582 93.1757 119.005C95.1785 119.317 96.9811 121.677 97.1591 123.858L97.7822 129.69Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6875 124.593C93.6875 124.593 92.8419 124.192 92.7306 124.148C92.2855 124.014 92.1742 123.591 92.1075 123.346C92.0185 122.946 92.3745 122.612 92.8196 122.656C93.1089 122.701 93.5317 123.057 93.554 123.391L93.6875 124.593Z",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3887 95.2301L94.2442 76.3083C95.3569 73.6815 96.7367 71.1661 98.3389 68.7842L101.276 64.421C103.368 61.3268 104.525 57.676 104.57 53.9361L104.614 50.4189C104.659 47.3247 103.947 44.2527 102.567 41.4923L98.7395 33.9014",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.829 49.7734C110.734 56.051 103.279 60.6145 103.279 60.6145",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.857 58.3662L116.186 59.1899C107.018 62.0393 98.3389 68.8066 98.3389 68.8066",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.843 75.707L108.709 75.9742C107.708 77.9999 106.217 79.7363 104.348 80.9829L99.6521 84.1439C98.8065 84.7227 98.0053 85.3237 97.2265 85.9916L86.4111 95.2298",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8909 56.5186C95.8909 56.5186 98.005 64.7551 94.8672 74.9283",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.258 92.7147L116.742 89.4646C115.185 88.0177 113.382 86.8824 111.401 86.081L110.111 85.569C107.819 84.6563 105.326 84.2778 102.856 84.4559L99.0283 84.5227",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.619 72.0342L122.061 73.7483C120.415 75.5737 118.523 77.1542 116.453 78.4898L115.875 78.8683C113.338 80.4933 110.578 81.6954 107.685 82.4745L99.0732 84.5671",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.329 82.2744C122.329 82.2744 111.691 82.7196 108.175 83.1203C106.15 83.3429 100.164 84.456 100.164 84.456",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.76 100.284L108.575 95.2749C106.216 92.9821 102.99 91.8245 99.7183 92.0694L88.5469 92.9153",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.505 104.513L105.26 101.218C105.149 99.7043 104.37 97.7008 103.302 96.5877C103.302 96.5877 99.8968 93.0037 97.627 92.2246",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.661 41.6709L106.617 41.8935C106.239 43.6076 105.571 44.8765 104.592 46.3234",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2323_21497",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 102,
    width: 42,
    height: 41
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4671 102.688H6.27539V142.757H47.4671V102.688Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2323_21497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.354 141.667C28.7513 134.922 14.6424 121.164 7.3877 103.823",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2323_21497",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 102,
    width: 43,
    height: 41
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M130.117 102.688H88.9258V142.757H130.117V102.688Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2323_21497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.0381 141.667C107.641 134.922 121.75 121.164 129.004 103.823",
    stroke: "#2A7077",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneticAncestry);
export default __webpack_public_path__ + "static/media/genetic_ancestry.c875edfcef92243fe6fc543540a1c959.svg";
export { ForwardRef as ReactComponent };